import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import { AlertBannerContext } from "@kivunova/kivufrontendcommon";
import { fetchGraphQL } from "../../Graphql/utils";
import {
  listPaymentsQuery,
  listAllPaymentsSuperAdminQuery,
  getPaymentQuery,
} from "../../Graphql/querries/paymentQuery";
import {
  ListPaymentsResponse,
  ListAllPaymentsSuperAdminResponse,
  GetPaymentResponse,
  ListPaymentsInput,
  ListAllPaymentsSuperAdminInput,
  GetPaymentInput,
} from "../../Graphql/types/payment";

export const useGetPaymentList = () => {
  const { setAlert } = useContext(AlertBannerContext);

  return useMutation<ListPaymentsResponse, Error, ListPaymentsInput>({
    mutationKey: ["listPayments"],
    mutationFn: (input) => fetchGraphQL(listPaymentsQuery, { input }, setAlert),
  });
};

/** Super admin: list all payments with optional filters. */
export const useListAllPaymentsSuperAdmin = () => {
  const { setAlert } = useContext(AlertBannerContext);

  return useMutation<
    ListAllPaymentsSuperAdminResponse,
    Error,
    ListAllPaymentsSuperAdminInput
  >({
    mutationKey: ["listAllPaymentsSuperAdmin"],
    mutationFn: (input) =>
      fetchGraphQL(listAllPaymentsSuperAdminQuery, { input }, setAlert),
  });
};

export const useGetPaymentDetail = () => {
  const { setAlert } = useContext(AlertBannerContext);

  return useMutation<GetPaymentResponse, Error, GetPaymentInput>({
    mutationKey: ["getPayment"],
    mutationFn: (input) => fetchGraphQL(getPaymentQuery, { input }, setAlert),
  });
};
